<template>
  <div class="subject-competency">
    <div v-if="questionAlreadyFilledIn===false">
      <span class="sd-notif warning text-left mt-2" style="margin-bottom: 15px;">
        <svg-icon icon="information" class="warning-icon" />
        <div class="list-container">
          <strong>Selecteer hieronder het (hoofd)vak dat je kunt geven.</strong>
          <div>
            Kies hier je hoofdvak, zodat je daar direct vacatures voor kunt zien. <br>
            Kun je meerdere vakken geven? Dit kun je alvast aangeven bij 'toelichting'. <br>
            In het (digitale) intakegesprek nemen we samen alle mogelijkheden door. <br>
            Derect vult jouw profiel dan verder aan met aanvullende informatie.
          </div>
        </div>
      </span>
    </div>
    <div v-else>
      <span class="sd-notif warning text-left mt-2" style="margin-bottom: 15px;">
        <svg-icon icon="information" class="warning-icon" />
        <div>Onderstaand vind je de vakken waarvoor jij beschikbaar bent via Derect. Iets wijzigen of aanvullen? Neem dan <router-link :to="{ name: 'contact' }">contact</router-link> met ons op.</div>
      </span>
    </div>
    <div class="sd-form">
      <div v-if="questionAlreadyFilledIn===false" class="input-row">
        <div class="question-title sd-input w-square-icon sd-col-12 form-group">
          <label>Vak</label>
          <select v-model="form.subject" class="custom-select form-control">
            <option selected="selected" disabled="true" value="">Selecteer je hoofdvak</option>
            <optgroup v-for="(subjects, category) in subjectCategories" :label="category">
              <option v-for="subject in subjects" :value="subject.id">{{ subject.answer }}</option>
            </optgroup>
          </select>
          <div class="icon-wrapper dropdown position-absolute align-self-center">
            <svg-icon icon="chevron_s" />
          </div>
        </div>
<!--        <div v-if="getSubjectCategory(form.subject) === 'Vmbo-profiel'" class="sd-col-12">-->
<!--          <div class="input-row qualified" style="margin-bottom: 0">-->
<!--            <div class="question-title sd-input w-square-icon sd-col-4 form-group">-->
<!--              <label>Bevoegdheid</label>-->
<!--              <select v-model="form.qualified" class="custom-select form-control">-->
<!--      &lt;!&ndash;          <option selected="selected" disabled="true">Selecteer</option>&ndash;&gt;-->
<!--                <option selected="selected" disabled="true" value="">Bevoegdheid</option>-->
<!--                <option value="false">Geen</option>-->
<!--                <option value="2e graads">Bevoegd</option>-->
<!--              </select>-->
<!--              <div class="icon-wrapper dropdown position-absolute align-self-center">-->
<!--                <svg-icon icon="chevron_s" />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="question-title sd-input w-square-icon sd-col-4 form-group">-->
<!--              <label>Studerend</label>-->
<!--              <select v-model="form.studying" class="custom-select form-control">-->
<!--      &lt;!&ndash;          <option selected="selected" disabled="true">Selecteer</option>&ndash;&gt;-->
<!--                <option selected="selected" disabled="true" value="">Studerend</option>-->
<!--                <option value="false">Geen</option>-->
<!--                <option value="2e graads">Studerend</option>-->
<!--              </select>-->
<!--              <div class="icon-wrapper dropdown position-absolute align-self-center">-->
<!--                <svg-icon icon="chevron_s" />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="question-title sd-input w-square-icon sd-col-4 form-group">-->
<!--              <label>Ervaring</label>-->
<!--              <select v-model="form.experienced" class="custom-select form-control">-->
<!--      &lt;!&ndash;          <option selected="selected" disabled="true">Selecteer</option>&ndash;&gt;-->
<!--                <option selected="selected" disabled="true" value="">Ervaring</option>-->
<!--                <option value="false">Geen</option>-->
<!--                <option value="2e graads">Ervaring</option>-->
<!--              </select>-->
<!--              <div class="icon-wrapper dropdown position-absolute align-self-center">-->
<!--                <svg-icon icon="chevron_s" />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div v-else class="sd-col-12">-->
<!--          <div class="input-row qualified" style="margin-bottom: 0">-->
<!--            <div class="question-title sd-input w-square-icon sd-col-4 form-group">-->
<!--              <label>Bevoegdheid</label>-->
<!--              <select v-model="form.qualified" class="custom-select form-control">-->
<!--  &lt;!&ndash;                <option selected="selected" disabled="true">Selecteer</option>&ndash;&gt;-->
<!--                <option selected="selected" disabled="true" value="">Bevoegdheid</option>-->
<!--                <option value="false">Geen</option>-->
<!--                <option value="1e graads">1e graads</option>-->
<!--                <option value="2e graads">2e graads</option>-->
<!--                <option value="Beide">Beide</option>-->
<!--              </select>-->
<!--              <div class="icon-wrapper dropdown position-absolute align-self-center">-->
<!--                <svg-icon icon="chevron_s" />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="question-title sd-input w-square-icon sd-col-4 form-group">-->
<!--              <label>Studerend</label>-->
<!--              <select v-model="form.studying" class="custom-select form-control">-->
<!--  &lt;!&ndash;                <option selected="selected" disabled="true">Selecteer</option>&ndash;&gt;-->
<!--                <option selected="selected" disabled="true" value="">Studerend</option>-->
<!--                <option value="false">Geen</option>-->
<!--                <option value="1e graads">1e graads</option>-->
<!--                <option value="2e graads">2e graads</option>-->
<!--                <option value="Beide">Beide</option>-->
<!--              </select>-->
<!--              <div class="icon-wrapper dropdown position-absolute align-self-center">-->
<!--                <svg-icon icon="chevron_s" />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="question-title sd-input w-square-icon sd-col-4 form-group">-->
<!--              <label>Ervaring</label>-->
<!--              <select v-model="form.experienced" class="custom-select form-control">-->
<!--  &lt;!&ndash;                <option selected="selected" disabled="true">Selecteer</option>&ndash;&gt;-->
<!--                <option selected="selected" disabled="true" value="">Ervaring</option>-->
<!--                <option value="false">Geen</option>-->
<!--                <option value="1e graads">1e graads</option>-->
<!--                <option value="2e graads">2e graads</option>-->
<!--                <option value="Beide">Beide</option>-->
<!--              </select>-->
<!--              <div class="icon-wrapper dropdown position-absolute align-self-center">-->
<!--                <svg-icon icon="chevron_s" />-->
<!--              </div>-->
<!--            </div>-->
<!--&lt;!&ndash;            <select v-model="form.can_also_give" style="width: 25%; float: left; margin-right: 10px;">&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;                <option selected="selected" disabled="true">Selecteer</option>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;              <option selected="selected" disabled="true" value="">Kan ook geven</option>&ndash;&gt;-->
<!--&lt;!&ndash;              <option value="false">Geen</option>&ndash;&gt;-->
<!--&lt;!&ndash;              <option value="1e graads">1e graads</option>&ndash;&gt;-->
<!--&lt;!&ndash;              <option value="2e graads">2e graads</option>&ndash;&gt;-->
<!--&lt;!&ndash;              <option value="Beide">Beide</option>&ndash;&gt;-->
<!--&lt;!&ndash;            </select>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div v-else>
        <label class="text text-yellow"><b>Vakken</b></label>
        <template v-for="(subjects, category) in subjectCategories">
          <div v-for="subject in subjects" class="details position-relative mb-4">
            <label class="text text-yellow d-block mb-0" v-if="hasGivenAnswers(subject)">{{ subject.answer }}</label>
            <span v-for="(qualification, type) in getGivenAnswers(subject)" class="d-block">
              <template>
                <template v-if="qualification != false && category !== 'Vmbo-profiel'" >
                  <span v-if="type === 'studying'">Studerend</span>
                  <span v-if="type === 'qualified'">Bevoegd</span>
                  <span v-if="type === 'experienced'">Ervaring</span>
                  <span v-if="type === 'can_also_give'">Kan ook geven</span>
                  <span v-if="qualification === 'Beide'">: 1e en 2e graads</span>
                  <span v-else>: {{ qualification }}</span>
                </template>
                <template v-if="qualification != false && category === 'Vmbo-profiel'" >
                  <span v-if="type === 'studying'">Studerend</span>
                  <span v-if="type === 'qualified'">Bevoegd</span>
                  <span v-if="type === 'experienced'">Ervaring</span>
                  <span v-if="type === 'can_also_give'">Kan ook geven</span>
                  <span></span>
                </template>
              </template>
            </span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      subjectCategories: {},
      isVisible: {},
      form: {
        subject: "",
        qualified: "Beide",
        studying: "",
        experienced: "",
        can_also_give: ""
      },
      questionAlreadyFilledIn: false
    };
  },
  mounted() {
    this.orderByCategory();
    this.setVisibility();
    this.setSubjectAnswers();
  },
  props: {
    value: Object,
    answersGiven: Object,
    question: Object,
    answers: Array,
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler() {

          var anAnswersGiven = false;

          Object.entries(this.value).forEach(([id, item]) => {
            if ((item.experienced !== false && item.experienced !== undefined) ||
                (item.qualified !== false && item.qualified !== undefined) ||
                (item.studying !== false && item.studying !== undefined) ||
                (item.can_also_give !== false && item.can_also_give !== undefined)) {
              anAnswersGiven = true;
              return;
            }
          });

          if(anAnswersGiven === true) {
            return;
          }

        let self = this;

        Object.entries(this.value).forEach(([id, item]) => {
          id = parseInt(id);

          if(self.form.subject === 0 || self.form.subject === "" || self.form.subject === null) {
            self.value[id].experienced = false;
            self.value[id].qualified = false;
            self.value[id].studying = false;
            self.value[id].can_also_give = false;
          } else {
            if(id === self.form.subject){
              self.value[id].experienced = self.form.experienced===""?false:self.form.experienced;
              self.value[id].qualified = self.form.qualified===""?false:self.form.qualified;
              self.value[id].studying = self.form.studying===""?false:self.form.studying;
              self.value[id].can_also_give = self.form.can_also_give===""?false:self.form.can_also_give;
            } else {
              self.value[id].experienced = false;
              self.value[id].qualified = false;
              self.value[id].studying = false;
              self.value[id].can_also_give = false;
            }
          }
        });
      }
    }
  },
  methods: {
    orderByCategory(){
      Object.values(this.answers).forEach(answer => {
        if (!this.subjectCategories.hasOwnProperty(answer.sub_category)) {
            this.$set(this.subjectCategories, answer.sub_category, []);
        }

        this.subjectCategories[answer.sub_category].push(answer);
      });
    },
    setVisibility(){
      Object.keys(this.subjectCategories).forEach(category => {
        this.$set(this.isVisible, category, false);
      });
    },
    setSubjectAnswers(){
      this.answers.forEach(answer => {
        if(!this.answersGiven.hasOwnProperty(answer.id)) {
          this.$set(this.answersGiven, answer.id, {
            studying: false,
            qualified: false,
            experienced: false,
          });
        } else {
          this.questionAlreadyFilledIn = true;

          if(!this.answersGiven[answer.id].hasOwnProperty('studying')) {
            this.$set(this.answersGiven[answer.id], 'studying' , false);
          }

          if(!this.answersGiven[answer.id].hasOwnProperty('qualified')) {
            this.$set(this.answersGiven[answer.id], 'qualified' , false);
          }

          if(!this.answersGiven[answer.id].hasOwnProperty('experienced')) {
            this.$set(this.answersGiven[answer.id], 'experienced' , false);
          }
        }
      });
    },
    getGivenAnswers(subject) {
      const result = {};

      if (this.answersGiven[subject.id]) {
        const properties = ['can_also_give', 'experienced', 'qualified', 'studying'];
        properties.forEach(key => {
          if (this.answersGiven[subject.id][key] && this.answersGiven[subject.id][key] !== 'false') {
            result[key] = this.answersGiven[subject.id][key];
          }
        });
      }

      return result;
    },
    hasGivenAnswers(subject) {
      return Object.keys(this.getGivenAnswers(subject)).length > 0;
    },

    toggleVisibility(category) {
      this.$set(this.isVisible, category, !this.isVisible[category]);
    },
    getSubjectCategory(subject){
      let subjectCategory;

      this.answers.forEach(answer => {
        if(answer.id === subject) {
          subjectCategory = answer.sub_category;
        }
      });

      return subjectCategory;
    }
  }

}
</script>

<style scoped>
/* Transition start */
.slide-enter-active {
  transition: .3s ease-in-out;
}

.slide-leave-active {
  transition: .3s cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 600px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
/* Transition end */

.subject-competency {

}

.subject-competency .subject-title {
  display: flex;
  position: relative;
  align-items: center;
  font-weight: 500;
  font-size: 20px;
  cursor: pointer;
  justify-content: space-between;
}

.subject-competency .subject-title .toggle-submenu {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  width: 15px;
  margin-left: 10px;
}

.subject-competency .subject-title .toggle-submenu::before,
.subject-competency .subject-title .toggle-submenu::after {
  position: absolute;
  display: block;
  content: '';
  height: 2px;
  width: 15px;
  background-color: #000;
  transition: .3s ease-in-out;
}

.subject-competency .subject-title:not(.opened) .toggle-submenu::after {
  transform: rotateZ(90deg);
}

.subject-competency .competency-container .subject-container {
  background-color: #f6f6f6;
  border-radius: 10px;
  padding: 15px;
  font-family: "Real Head Pro", sans-serif;
}

.subject-competency .competency-container .subject-container {
  margin-bottom: 15px;
}

.subject-competency .competency-container .subject-choices {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #FFF;
  border-radius: 15px;
  margin-bottom: 15px;
}

.subject-competency .competency-container .subject-question,
.subject-competency .competency-container .subject-headers {
  display: grid;
  grid-template-columns: 220px 95px 95px 95px;
  gap: 10px;
  padding: 10px 15px;
  align-items: center;
}

.subject-competency .competency-container .subject-choice-container {
  background-color: #f6f6f6;
  padding: 15px;
  border-radius: 10px;
}

.subject-competency .competency-container .subject-choice-container .subject-container {
  border: 0;
  background-color: #FFF;
  width: 100%;
  margin-bottom: 0;
}

.subject-competency .competency-container .subject-choice-container .question-option.qualified {
  display: flex !important;
  flex-direction: row;
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 15px;
  background-color: #FFF;
}

.subject-competency .competency-container .subject-choice-container .subject-addition {
  margin-top: 15px;
}

.subject-competency .text.text-yellow.d-block.mb-0 {
  font-weight: normal;
}

.subject-headers {
  font-weight: 500;
}

.question-option,
.choice-title {
  display: flex;
  flex-direction: column;
}

.question-option select {
  border: none;
  cursor: pointer;
  font-family: "Real Head Pro", sans-serif;
}

.question-option option {
  font-family: "Real Head Pro", sans-serif;
}

/*.qualified {
  //border: 1px solid red;
}

.studying {
  //border: 1px solid green;
}

.experience {
  //border: 1px solid blue;
}*/

.sd-notif .list-container ul {
  padding-left: 18px;
}

@media screen and (min-width: 670px) {
  .subject-competency .competency-container.mobile {
    display: none;
  }
}

@media screen and (max-width: 670px) {
  .subject-competency .competency-container:not(.mobile) {
    display: none;
  }
  .subject-competency .competency-container.mobile {
    display: block;
  }

  .subject-competency .competency-container.mobile .subject-question {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .subject-competency .competency-container.mobile .subject-question .question-option {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }

  .subject-competency .competency-container.mobile .subject-question .question-option .choice-title {
    margin-right: 10px;
  }

  .subject-competency .competency-container.mobile .subject-question .question-title {
    font-weight: 400;
  }
}

</style>